<div class="container" *ngIf="showNavBar">
  <nav class="left-nav" aria-label="Main Navigation">
    <ul class="nav-list">
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link" routerLink="/dashboard">
          <span class="nav-text">Home</span>
        </a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" [ngClass]="isDisabled ? 'disabled' : ''" [attr.aria-disabled]="isDisabled ? 'true' : null">
        <a class="nav-link" routerLink="/applicant-list">
          <span class="nav-text">Applicants</span>
        </a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" *ngIf="isAdmin || isSuperAdmin">
        <a class="nav-link" routerLink="/user-management">
          <span class="nav-text">Users</span>
        </a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" *ngIf="isEligibilityAutoDetermined == false">
        <a class="nav-link" routerLink="/case-list">
          <span class="nav-text">Cases</span>
        </a>
      </li>
    </ul>
  </nav>
</div>
